var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 16,
    fill: "#FFE4E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6244_56247)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2996 17.0996H50.6996C53.0096 17.0996 54.8996 18.9896 54.8996 21.2996V50.6996C54.8996 53.0096 53.0096 54.8996 50.6996 54.8996H21.2996C18.9896 54.8996 17.0996 53.0096 17.0996 50.6996L17.1206 21.2996C17.1206 18.9896 18.9896 17.0996 21.2996 17.0996ZM32.8496 46.4996H39.1496V39.1496H46.4996V32.8496H39.1496V25.4996H32.8496V32.8496H25.4996V39.1496H32.8496V46.4996Z",
    fill: "#F44067"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6244_56247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.4,
    height: 50.4,
    fill: "white",
    transform: "translate(10.7998 10.7998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCare);
export default __webpack_public_path__ + "static/media/care.e85cbbf8473fb3006ed5f1e6a569e271.svg";
export { ForwardRef as ReactComponent };